import Icon from "@ant-design/icons";
import type { GetProps } from "antd";
type CustomIconComponentProps = GetProps<typeof Icon>;

export const MeetingPersonalSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 14 14"
  >
    <path d="M0 0h14v14H0z" fill="none" />
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="m2.547 1.416l.232-.013C4.156 1.328 5.562 1.25 7 1.25s2.844.078 4.22.153l.233.013c.66.036 1.17.506 1.23 1.084c.088.85.088 1.627 0 2.477c-.06.578-.57 1.048-1.23 1.084l-.232.013c-1.377.075-2.783.153-4.221.153s-2.844-.078-4.22-.153l-.233-.013c-.66-.036-1.17-.506-1.23-1.084a11.6 11.6 0 0 1 0-2.477c.06-.578.57-1.048 1.23-1.084M7 0C5.526 0 4.089.08 2.72.155l-.241.013C1.286.233.205 1.105.074 2.37c-.097.935-.097 1.8 0 2.735c.131 1.266 1.212 2.138 2.405 2.203l.24.013c1.37.076 2.807.155 4.281.155s2.911-.08 4.28-.155l.241-.013c1.192-.065 2.274-.937 2.405-2.203c.097-.935.097-1.8 0-2.735c-.131-1.266-1.213-2.138-2.405-2.203l-.24-.013C9.91.079 8.474 0 7 0m1.896 2.725a.625.625 0 0 0-.84-.926c-.5.454-.886.872-1.213 1.383c-.176.274-.33.568-.475.897l-.393-.406a.625.625 0 0 0-.898.87L6.149 5.65a.625.625 0 0 0 1.04-.23c.245-.704.457-1.174.707-1.565c.247-.386.548-.72 1-1.13M2.445 11.48a2.85 2.85 0 0 0-1.943 2.045a.383.383 0 0 0 .37.475h4.789a.382.382 0 0 0 .37-.475A2.85 2.85 0 0 0 4.09 11.48q.218-.103.392-.275c.308-.308.443-.737.443-1.216s-.135-.907-.443-1.215s-.736-.444-1.214-.444s-.906.136-1.214.444s-.443.736-.443 1.215s.136.908.443 1.216q.174.172.392.275m7.466 0a2.85 2.85 0 0 0-1.944 2.045a.383.383 0 0 0 .372.475h4.787a.382.382 0 0 0 .372-.475a2.85 2.85 0 0 0-1.943-2.045q.218-.103.392-.275c.307-.308.443-.737.443-1.216s-.136-.907-.443-1.215c-.308-.308-.736-.444-1.214-.444c-.479 0-.906.136-1.214.444s-.443.736-.443 1.215s.135.908.443 1.216q.174.172.392.275"
      clip-rule="evenodd"
    />
  </svg>
);

export const MeetingPersonalIcon = (
  props: Partial<CustomIconComponentProps>,
) => <Icon component={MeetingPersonalSvg} {...props} />;
export default MeetingPersonalIcon;
